import { useNavigate } from "react-router-dom";
import {
  CommandDialog,
  CommandInput,
  CommandList,
  CommandEmpty,
  CommandGroup,
  CommandItem,
} from "@/components/ui/command";
import { SEARCH_INDEX } from "@/data/searchIndex";
import { Ticket, MapPin, Sparkles, BookOpen, HelpCircle, ArrowRight } from "lucide-react";

const TYPE_META = {
  Ticket: { icon: Ticket },
  "Plan Your Visit": { icon: MapPin },
  Highlight: { icon: Sparkles },
  Guide: { icon: BookOpen },
  FAQ: { icon: HelpCircle },
};

const ORDER = ["Ticket", "Plan Your Visit", "Highlight", "Guide", "FAQ"];

export const SearchDialog = ({ open, onOpenChange }) => {
  const navigate = useNavigate();

  const grouped = ORDER.map((type) => ({
    type,
    items: SEARCH_INDEX.filter((i) => i.type === type),
  })).filter((g) => g.items.length);

  const go = (to) => {
    onOpenChange(false);
    navigate(to);
  };

  return (
    <CommandDialog open={open} onOpenChange={onOpenChange}>
      <CommandInput placeholder="Search tickets, guides, planning & FAQs…" data-testid="search-input" />
      <CommandList className="max-h-[60vh]">
        <CommandEmpty>No results found. Try “underground”, “opening hours” or “family”.</CommandEmpty>
        {grouped.map((group) => {
          const Icon = (TYPE_META[group.type] || {}).icon || Sparkles;
          return (
            <CommandGroup key={group.type} heading={group.type}>
              {group.items.map((item, i) => (
                <CommandItem
                  key={item.to + i}
                  value={`${item.title} ${item.keywords}`}
                  onSelect={() => go(item.to)}
                  data-testid={`search-result-${item.to}`}
                  className="group cursor-pointer gap-3 rounded-lg px-3 py-2.5 data-[selected=true]:bg-sand"
                >
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-gold/10 text-gold-dark">
                    <Icon size={16} />
                  </span>
                  <span className="flex flex-col">
                    <span className="font-medium text-charcoal">{item.title}</span>
                    <span className="text-xs text-slatey line-clamp-1">{item.description}</span>
                  </span>
                  <ArrowRight size={15} className="ml-auto text-stone-line group-data-[selected=true]:text-gold" />
                </CommandItem>
              ))}
            </CommandGroup>
          );
        })}
      </CommandList>
    </CommandDialog>
  );
};

export default SearchDialog;
